<template>
  <div class="socks-reactivation-page">
    <LandingPageBody v-bind="landingPageProps" />
  </div>
</template>

<script>
import LandingPageBody from '@/components/CampaignLandingPage/LandingPageBody'
import { LandingPageType } from '@/enums/landing'
import { AUTH_ID } from '@/utils/store/getterTypes'
import { mapState, mapGetters } from 'vuex'

export default {
  name: 'SocksReactivationLandingPage',
  layout: 'homepage-signup-button',
  components: {
    LandingPageBody
  },
  computed: {
    landingPageProps () {
      return {
        locizePath: 'LandingPage.SocksReactivation',
        imagePath: '/images/frontend/reactivation/socks/',
        appCountry: this.country,
        locale: this.locale,
        userIdentifier: this.userId,
        landingpageUrl: '/socks/reactivate',
        primaryColor: this.$t('LandingPage.SocksReactivation.HexColor'),
        type: LandingPageType.reactivate
      }
    },
    ...mapState('app', {
      country: state => state.country,
      locale: state => state.locale
    }),
    ...mapGetters('auth', {
      userId: AUTH_ID
    })
  }
}
</script>

<style scoped lang="postcss">
.socks-reactivation-page {
  >>> {
    .landingpage-hero-title,
    .landingpage-hero-description {
      @apply text-gray-600;
    }
  }
}
</style>
